export const CrossIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.8696 12.2469L11.7103 6.42042" stroke="#191B1F" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.87669 6.41333L11.7032 12.2541" stroke="#191B1F" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
